import { render, staticRenderFns } from "./PointManagementIndex.vue?vue&type=template&id=e08e6bda&scoped=true"
import script from "./PointManagementIndex.vue?vue&type=script&lang=js"
export * from "./PointManagementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08e6bda",
  null
  
)

export default component.exports